import React, { useCallback, useMemo } from 'react';
import { Analytics, type BeforeSendEvent } from '@vercel/analytics/react';
import { useLocation } from 'react-router-dom';
import {
  getAnalyticsRoute,
  isPageViewAnalyticsAllowed,
  sanitizeVercelAnalyticsEvent,
} from './routePrivacy';

const AnalyticsRuntime: React.FC = () => {
  const location = useLocation();

  const route = useMemo(() => getAnalyticsRoute(location.pathname), [location.pathname]);
  const enabled = Boolean(route && typeof window !== 'undefined' && isPageViewAnalyticsAllowed(
    window.location.hostname,
    process.env.NODE_ENV === 'production',
    location.pathname,
  ));
  const beforeSend = useCallback(
    (event: BeforeSendEvent) => sanitizeVercelAnalyticsEvent(event),
    [],
  );

  if (!enabled || !route) return null;

  return (
    <Analytics
      route={route}
      path={route}
      beforeSend={beforeSend}
      debug={false}
    />
  );
};

export default AnalyticsRuntime;
